import request from '@/utils/request'

// 新闻资讯列表
export function industryList(query) {
    return request({
        url: '/petroleum/industry/newsList',
        method: 'get',
        params: query
    })
}

// 新闻资讯详情
export function industryDetail(id) {
    return request({
        url: `/petroleum/industry/news/${id}`,
        method: 'get',
    })
}

// 价格列表
export function priceList(query) {
    return request({
        url: '/petroleum/metatron/price/hydrogenPriceList',
        method: 'get',
        params: query
    })
}

// 价格列表
export function priceListXin(query) {
    return request({
        url: '/petroleum/industry/newsHydrogenPriceList',
        method: 'get',
        params: query
    })
}

// 价格详情
export function priceDetail(query) {
    return request({
        url: `/petroleum/metatron/price/detailsHydrogenPriceList`,
        method: 'get',
        params:query
    })
}

// 价格详情
export function priceDetailXin(id) {
    return request({
        url: `/petroleum/industry/newsHydrogenPrice/${id}`,
        method: 'get',
    })
}

// 市场点评列表
export function commentList(query) {
    return request({
        url: '/petroleum/industry/newsMarketCommentsList',
        method: 'get',
        params: query
    })
}

// 市场点评详情
export function commentDetail(id) {
    return request({
        url: `/petroleum/industry/newsMarketComments/${id}`,
        method: 'get',
    })
}

// 研究报告列表
export function reportList(query) {
    return request({
        url: '/petroleum/report/hydrogenMonthReportList',
        method: 'get',
        params: query
    })
}

// 研究报告详情
export function reportDetail(id) {
    return request({
        url: `/petroleum/report/hydrogenMonthReportInfo/${id}`,
        method: 'get',
    })
}

// 重点企业开工率列表
export function rateList(query) {
    return request({
        url: '/petroleum/metatron/rate/hydrogenRateList',
        method: 'get',
        params: query
    })
}

// 重点企业开工率详情
export function rateDetail(query) {
    return request({
        url: `/petroleum/metatron/rate/detailsHydrogenRateList`,
        method: 'get',
        params:query
    })
}

// 重点企业产量列表
export function yieldList(query) {
    return request({
        url: '/petroleum/metatron/yield/companyYieldList',
        method: 'get',
        params: query
    })
}

// 重点企业产量详情
export function yieldDetail(query) {
    return request({
        url: `/petroleum/metatron/yield/detailsCompanyYieldList`,
        method: 'get',
        params:query
    })
}

// 氢能产业链列表
export function propertyList(query) {
    return request({
        url: '/petroleum/industry/newsChainList',
        method: 'get',
        params: query
    })
}

// 氢能产业链详情
export function propertyDetail(id) {
    return request({
        url: `/petroleum/industry/newsChainPrice/${id}`,
        method: 'get',
    })
}

// 加氢站列表
export function stationList(query) {
    return request({
        url: '/petroleum/industry/newsHydrogenationList',
        method: 'get',
        params: query
    })
}

// 加氢站详情
export function stationDetail(id) {
    return request({
        url: `/petroleum/industry/newsHydrogenationPrice/${id}`,
        method: 'get',
    })
}

// 项目一览列表
export function projectStationList(query) {
    return request({
        url: '/petroleum/report/projectReportList',
        method: 'get',
        params: query
    })
}

// 项目一览详情
export function projectStationDetail(id) {
    return request({
        url: `/petroleum/report/projectReport/${id}`,
        method: 'get',
    })
}

// 燃料电池列表
export function batteryList(query) {
    return request({
        url: '/petroleum/industry/newsFuelCellList',
        method: 'get',
        params: query
    })
}

// 燃料电池详情
export function batteryDetail(id) {
    return request({
        url: `/petroleum/industry/newsFuelCellInfo/${id}`,
        method: 'get',
    })
}

// 新建项目列表
export function projectList(query) {
    return request({
        url: '/petroleum/industry/newsNewProjectList',
        method: 'get',
        params: query
    })
}

// 新建项目详情
export function projectDetail(id) {
    return request({
        url: `/petroleum/industry/newsNewProjectPrice/${id}`,
        method: 'get',
    })
}

// 区域规划列表
export function planList(query) {
    return request({
        url: '/petroleum/industry/newsRegionalList',
        method: 'get',
        params: query
    })
}

// 区域规划详情
export function planDetail(id) {
    return request({
        url: `/petroleum/industry/newsRegionalPrice/${id}`,
        method: 'get',
    })
}

// 加氢站月报列表
export function monthList(query) {
    return request({
        url: '/petroleum/report/monthAddReportList',
        method: 'get',
        params: query
    })
}

// 加氢站月报详情
export function monthDetail(id) {
    return request({
        url: `/petroleum/report/monthAddReport/${id}`,
        method: 'get',
    })
}

// 项目数据库列表
export function databaseList(query) {
    return request({
        url: '/petroleum/industry/newsDatabaseList',
        method: 'get',
        params: query
    })
}

// 项目数据库详情
export function databaseDetail(id) {
    return request({
        url: `/petroleum/industry/newsDatabasePrice/${id}`,
        method: 'get',
    })
}

// 项目数据库列表（报表）
export function databaseReList(query) {
    return request({
        url: '/petroleum/report/databaseReportList',
        method: 'get',
        params: query
    })
}

// 项目数据库详情（报表）
export function databaseReDetail(id) {
    return request({
        url: `/petroleum/report/databaseReport/${id}`,
        method: 'get',
    })
}

// 进出口列表
export function exitList(query) {
    return request({
        url: '/petroleum/metatron/exit/hydrogenExitList',
        method: 'get',
        params: query
    })
}

// 进出口详情
export function exitDetail(query) {
    return request({
        url: `/petroleum/metatron/exit/detailsHydrogenExitList`,
        method: 'get',
        params:query
    })
}

// 应用情况列表
export function batteryReList(query) {
    return request({
        url: '/petroleum/report/hydrogenApplicationReportList',
        method: 'get',
        params: query
    })
}

// 应用情况详情
export function batteryReDetail(id) {
    return request({
        url: `/petroleum/report/boardApplicationInfo/${id}`,
        method: 'get',
    })
}

// 地图
export function mapDetail(query) {
    return request({
        url: `/petroleum/company/getHydrogenEnergyMap`,
        method: 'get',
        params:query
    })
}

// 公司详情
export function companyDetail(id) {
    return request({
        url: `/petroleum/station/${id}`,
        method: 'get',
    })
}

// 加氢站类型
export function getDicts(dictType) {
    return request({
        url: '/system/dict/data/type/' + dictType,
        method: 'get',
    })
}

// 折线图
export function mapData(query) {
    return request({
        url: `/petroleum/metatron/detail/lineChart`,
        method: 'get',
        params:query
    })
}

// 柱状图
export function columnMapData(query) {
    return request({
        url: `/petroleum/metatron/detail/histogram`,
        method: 'get',
        params:query
    })
}